//#region src/server-side/is-client.ts
function e() {
	return typeof window < "u" && typeof document < "u";
}
//#endregion
export { e as isClient };
